import React from 'react';
import Drawer from '@atlaskit/drawer';

import { Edit } from '@/components/composed/forms';
import { EditContext } from '@/controllers';

function EditEntityDrawer() {
  const editEntityController = React.useContext(EditContext);
  return (
    <Drawer
      isOpen={editEntityController.isFormOpen}
      onClose={editEntityController.onClose}
      width="wide"
    >
      <Edit />
    </Drawer>
  );
}

export default EditEntityDrawer;
